module.exports = __webpack_public_path__ + "img/hero-background.3e7634a4.png";